module.exports = __webpack_public_path__ + "img/office-gray.0a4117d0.png";